import {intakeManage} from 'api';

export const INTAKEMANAGELIST = 'INTAKEMANAGELIST';


export const tableAction = (data) => ({
  type: INTAKEMANAGELIST,
  payload: {
    promise: intakeManage.list(data)
  }
});
